import React, { useCallback, useMemo } from 'react';
import { Button, Popup } from '@leverege/ui-elements';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DownloadPDF({
  submitIcon,
  submitText,
  productTypes,
  downloadContractPDF
}) {
  const types = useMemo(() => {
    return Object.entries(productTypes).reduce((prev, [key, value]) => {
      if (value) {
        prev.push(key);
      }
      return prev;
    }, []);
  }, [productTypes]);
  const onClick = useCallback(({
    data
  }) => {
    downloadContractPDF({
      productType: data
    });
  }, [downloadContractPDF]);
  if (types.length === 0) {
    return null;
  }
  return types.length < 2 ? /*#__PURE__*/_jsx(Button, {
    eventData: types[0],
    variant: "primary",
    onClick: onClick,
    icon: submitIcon,
    children: submitText
  }) : /*#__PURE__*/_jsxs(Popup, {
    title: "Download PDFs",
    icon: submitIcon,
    toggleVariant: "primary",
    children: [productTypes.recovr && /*#__PURE__*/_jsx(Popup.Item, {
      eventData: "recovr",
      onClick: onClick,
      children: "Recovr Contract PDF"
    }), productTypes.recovrKeys && /*#__PURE__*/_jsx(Popup.Item, {
      eventData: "recovrKeys",
      onClick: onClick,
      children: "Keys Contract PDF"
    })]
  });
}